import { IStore } from '../../interfaces/Store';
import {
  useQuery,
} from '@tanstack/react-query';
import { getPaymentFees, getStoreByIdV2, getStoreImagesV2, getStoresV2 } from '../../services/store.service';
import { IStoreImage } from '../../interfaces/StoreImage';

export const useGetStores = (
  isActive: boolean = true,
  enabled: boolean = true
) => useQuery<IStore[]>({
  queryKey: ['stores', { isActive }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { isActive }] = queryKey as [string, { isActive: boolean }]
      const res = await getStoresV2(isActive);
      if (!res) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res as unknown as IStore[];
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetStoreById = (enabled: boolean, storeId: string) => useQuery<IStore>({
  queryKey: ['store', { _id: storeId }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { _id: _id }] = queryKey as [string, { _id: string }];
      const res = await getStoreByIdV2(_id);
      if (!res) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res as unknown as IStore;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetStoreImages = (enabled: boolean, storeId: string) => useQuery<IStoreImage[]>({
  queryKey: ['storeImages', { _id: storeId }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key] = queryKey;
      const res = await getStoreImagesV2(storeId);
      if (!res.data?.data?.storeImages) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.storeImages;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetPaymentFees = (enabled: boolean, storeId: string) => useQuery<any>({
  queryKey: ['paymentFees', { _id: storeId }],
  enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key] = queryKey;
      const res = await getPaymentFees(storeId);
      if (!res) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});
